// extracted by mini-css-extract-plugin
module.exports = {"header":"SharedStyles_header__3nZJU","header_line":"SharedStyles_header_line__3-MdH","subHeader":"SharedStyles_subHeader__3mwmg","h4":"SharedStyles_h4__3ZCn8"};